module.exports = __webpack_public_path__ + "img/stuDetailIcon2@2x.bddc4a42.png";